import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { WidgetContentType } from 'Type/Widget.type';

import WidgetContentLocation from './WidgetContentLocation.component';

/** @namespace PeggysagePwa/Component/WidgetContentLocation/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    widgetContentItems: state.WidgetReducer.widgets
});

/** @namespace PeggysagePwa/Component/WidgetContentLocation/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/WidgetContentLocation/Container */
export class WidgetContentLocationContainer extends PureComponent {
    static propTypes = {
        widgetContentItems: PropTypes.arrayOf(WidgetContentType),
        container: PropTypes.string.isRequired
    };

    static defaultProps = {
        widgetContentItems: []
    };

    state = {
        widgets: []
    };

    containerFunctions = {
        // ...
    };

    componentDidMount() {
        this.updateWidgets();
    }

    componentDidUpdate(prevProps) {
        const { widgetContentItems } = this.props;
        const { widgetContentItems: prevWidgetContentItems } = prevProps;

        if (widgetContentItems !== prevWidgetContentItems) {
            this.updateWidgets();
        }
    }

    updateWidgets() {
        const { container, widgetContentItems } = this.props;

        this.setState({
            widgets: widgetContentItems.filter((widget) => widget.container === container)
        });
    }

    containerProps() {
        const { widgets } = this.state;

        return {
            widgets
        };
    }

    render() {
        return (
            <WidgetContentLocation
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetContentLocationContainer);
